// 3rd party imports
import * as React from 'react';

// Bernie
import { LocalizedText } from '@shared-ui/localization-context';
import { UitkDialogContent } from 'uitk-react-dialog';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkList } from 'uitk-react-list';

export interface PzFormInfoAccountProps {
  rules: string[];
}

export const PzFormInfoAccount: React.FunctionComponent<PzFormInfoAccountProps> = ({ rules }) => {
  return (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        <LocalizedText message="pz.signup.info.accountname.title" />
      </UitkHeading>
      <UitkText>
        <LocalizedText message="pz.signup.info.accountname.subtitle.name_by_which_your_acc_will_be_identified" />
      </UitkText>
      <UitkSpacing margin={{ blockstart: 'six' }}>
        <div>
          <UitkText>
            <LocalizedText message="pz.signup.info.accountname.text.account_name_rules" />
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'two' }}>
            <div>
              <UitkList data={rules} />
            </div>
          </UitkSpacing>
        </div>
      </UitkSpacing>
    </UitkDialogContent>
  );
};
